<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("GCAM & VAT Detailed Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getGcamDetailedReport((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="gcamRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getGcamDetailedReport((isExcel = 'Y'))"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="section-title my-3">
        {{ $t("Ticket plus F&B") }}
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Cinema Name</th>
            <th>Show Date</th>
            <th>Business Date</th>
            <!-- <th>Calendar Date</th> -->
            <th>Invoice</th>
            <th>Movie Name</th>
            <th>Type</th>
            <th>Ticket Class</th>
            <th>Before Vat Ticket Price</th>
            <th>Class Rate</th>
            <th>Qty</th>
            <th>Total Selling Price</th>
            <th>Vat%</th>
            <th>Vat Amount</th>
            <th>Before Vat</th>
            <th>GCAM%</th>
            <th>GCAM Amount</th>
          </thead>
          <tbody v-if="gcamRecords.length">
            <template v-for="(gcamData, gcamIndex) in gcamRecords">
              <tr
                :key="gcamIndex + 'GCAMRecords'"
                v-if="gcamData.hasOwnProperty('movie_id')"
              >
                <td class="text-left">{{ gcamData.cine_name }}</td>
                <td class="text-left">{{ gcamData.show_date }}</td>
                <td class="text-left">{{ gcamData.business_date }}</td>
                <!-- <td class="text-left">{{ gcamData.ss_start_date }}</td> -->
                <td class="text-left">T{{ gcamData.sb_id }}</td>
                <td class="text-left">
                  {{ gcamData.movie_name }}-{{ gcamData.movie_format || "" }}
                </td>
                <td class="text-left">Ticket</td>
                <td class="text-left">{{ gcamData.ticket_class }}</td>
                <td class="text-right">
                  {{ currFormat(gcamData.before_vat_price) || "0.0" }}
                </td>
                <td class="text-right">
                  {{ currFormat(gcamData.class_rate) || "0.0" }}
                </td>
                <td class="text-right">{{ gcamData.quantity }}</td>
                <td class="text-right">
                  {{ currFormat(gcamData.total_selling_price) || "0.0" }}
                </td>
                <td class="text-left">{{ gcamData.vat_percentage }}%</td>
                <td class="text-right">
                  {{ currFormat(gcamData.vat_amount) || "0.0" }}
                </td>
                <td class="text-right">
                  {{ currFormat(gcamData.before_vat) || "0.0" }}
                </td>
                <td class="text-right">{{ gcamData.gcam_percentage }}%</td>
                <td class="text-right">
                  {{ currFormat(gcamData.gcam_amount) || "0.0" }}
                </td>
              </tr>
              <tr :key="gcamIndex + 'GCAMRecordsFnB'" v-else>
                <td class="text-left">{{ gcamData.cine_name }}</td>
                <td class="text-left">{{ gcamData.t_show_date }}</td>
                <!-- <td class="text-left">{{ gcamData.payment_date }}</td> -->
                <td class="text-left">{{ gcamData.business_date }}</td>
                <td class="text-left">F{{ gcamData.ft_id }}</td>
                <td class="text-left">
                  {{ gcamData.fst_item_name }}
                </td>
                <td class="text-left">F&B</td>
                <td class="text-left">{{ gcamData.fc_category }}</td>
                <td class="text-right">
                  {{ currFormat(gcamData.before_vat_price) || "0.0" }}
                </td>
                <td class="text-right">
                  {{ currFormat(gcamData.class_rate) || "0.0" }}
                </td>
                <td class="text-right">{{ gcamData.fst_quantity }}</td>
                <td class="text-right">
                  {{ currFormat(gcamData.fp_total_amount) || "0.0" }}
                </td>
                <td class="text-left">
                  {{
                    gcamData.charge_type_name
                      ? gcamData.charge_type_name.split("-")[1]
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{ currFormat(gcamData.vat_amount) || "0.0" }}
                </td>
                <td class="text-right">
                  {{ currFormat(gcamData.before_vat) || "0.0" }}
                </td>
                <td class="text-right">-</td>
                <td class="text-right">
                  {{ currFormat(gcamData.gcam_amount) || "0.0" }}
                </td>
              </tr>
            </template>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="16">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-title my-3">
        {{ $t("F&B Records") }}
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Cinema Name</th>
            <th>Business Date</th>
            <th>Calender Date</th>
            <th>Invoice</th>
            <th>Item Name</th>
            <th>Type</th>
            <th>Category Name</th>
            <th>Before Vat Item Price</th>
            <th>Class Rate</th>
            <th>Qty</th>
            <th>Total Selling Price</th>
            <th>Vat%</th>
            <th>Vat Amount</th>
            <th>Before Vat</th>
            <th>GCAM%</th>
            <th>GCAM Amount</th>
          </thead>
          <tbody v-if="fnbGcamRecords.length > 0">
            <tr
              v-for="(fnbGcamData, fnbGcamDataIndex) in fnbGcamRecords"
              :key="fnbGcamDataIndex"
            >
              <td class="text-left">{{ fnbGcamData.cine_name }}</td>
              <td class="text-left">{{ fnbGcamData.business_date || "-" }}</td>
              <td class="text-left">{{ fnbGcamData.payment_date || "-" }}</td>
              <td class="text-left">F{{ fnbGcamData.ft_id }}</td>
              <td class="text-left">
                {{ fnbGcamData.fst_item_name }}
              </td>
              <td class="text-left">F&B</td>
              <td class="text-left">{{ fnbGcamData.fc_category }}</td>
              <td class="text-right">
                {{ currFormat(fnbGcamData.before_vat_price) || "0.0" }}
              </td>
              <td class="text-right">
                {{ currFormat(fnbGcamData.class_rate) || "0.0" }}
              </td>
              <td class="text-right">{{ fnbGcamData.fst_quantity }}</td>
              <td class="text-right">
                {{ currFormat(fnbGcamData.fp_total_amount) || "0.0" }}
              </td>
              <td class="text-left">
                {{
                  fnbGcamData.charge_type_name
                    ? fnbGcamData.charge_type_name.split("-")[1].split("%")[0]
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{ currFormat(fnbGcamData.vat_amount) || "0.0" }}
              </td>
              <td class="text-right">
                {{ currFormat(fnbGcamData.before_vat) || "0.0" }}
              </td>
              <td class="text-right">-</td>
              <td class="text-right">
                {{ currFormat(fnbGcamData.gcam_amount) || "0.0" }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="16">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      gcamRecords: [],
      fnbGcamRecords: [],
      excelFilePath: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate: function (e, type) {
      if (type == 'from') {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      // let orgName = this.getorgData[0].org_name;
      let cinemaName = this.dropDown.selectedCinemaName;
      let fromDate = this.from_date
        ? moment(this.from_date).format("YYYY-MM-DD")
        : null;
      let toDate = this.to_date
        ? moment(this.to_date).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let fileName =
        "RawMaterialSupplierWiseCost-" +
        cinemaName +
        "_" +
        fromDate +
        "_" +
        toDate +
        "_on " +
        dateTime +
        (type ? "." + type : ".xlsx");
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || fileName);
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getGcamDetailedReport(isExcel) {
      if (isExcel == "N") {
        this.gcamRecords = [];
        this.fnbGcamRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        from_date: moment(this.fromDate).format("YYYY-MM-DD"),
        to_date: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
      };
      ReportsService.GetGcamDetailedReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.gcamRecords = [...data.Records];
            this.fnbGcamRecords = [...data.fnbRecords];
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/GcamDetailedReport.vue